import * as types from 'actions/action-types';

var initialState = {

    asset_analytics: { topAssetArray: [] },
    analytics_assets: {},
    analytics_assets_top: [],
    analytics_assets_expiring: [],
    analytics_customers: {},
    analytics_customers_top: [],
    analytics_service_requests: {},
    analytics_quotes: {},
    analytics_invoices: {},
};

const analyticsReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.ASSET_ANALYTICS + '_CLEAR': state = { ...state, asset_analytics: { topAssetArray: [] }}; break;
		case types.ASSET_ANALYTICS + '_PENDING': pending('asset_analytics'); break;
		case types.ASSET_ANALYTICS + '_FULFILLED': fulfilled('asset_analytics'); break;
        
        case types.ANALYTICS_ASSETS + '_CLEAR': state = { ...state, analytics_assets: {} }; break;
		case types.ANALYTICS_ASSETS + '_PENDING': pending('analytics_assets'); break;
		case types.ANALYTICS_ASSETS + '_FULFILLED': fulfilled('analytics_assets'); break;

        case types.ANALYTICS_ASSETS_TOP + '_CLEAR': state = { ...state, analytics_assets_top: [] }; break;
		case types.ANALYTICS_ASSETS_TOP + '_PENDING': pending('analytics_assets_top'); break;
		case types.ANALYTICS_ASSETS_TOP + '_FULFILLED': fulfilled('analytics_assets_top'); break;

        case types.ANALYTICS_ASSETS_EXPIRING + '_CLEAR': state = { ...state, analytics_assets_expiring: []}; break;
		case types.ANALYTICS_ASSETS_EXPIRING + '_PENDING': pending('analytics_assets_expiring'); break;
		case types.ANALYTICS_ASSETS_EXPIRING + '_FULFILLED': fulfilled('analytics_assets_expiring'); break;

        case types.ANALYTICS_CUSTOMERS + '_CLEAR': state = { ...state, analytics_customers: {} }; break;
		case types.ANALYTICS_CUSTOMERS + '_PENDING': pending('analytics_customers'); break;
		case types.ANALYTICS_CUSTOMERS + '_FULFILLED': fulfilled('analytics_customers'); break;

        case types.ANALYTICS_CUSTOMERS_TOP + '_CLEAR': state = { ...state, analytics_customers_top: [] }; break;
		case types.ANALYTICS_CUSTOMERS_TOP + '_PENDING': pending('analytics_customers_top'); break;
		case types.ANALYTICS_CUSTOMERS_TOP + '_FULFILLED': fulfilled('analytics_customers_top'); break;

        case types.ANALYTICS_SERVICE_REQUESTS + '_CLEAR': state = { ...state, analytics_service_requests: {} }; break;
		case types.ANALYTICS_SERVICE_REQUESTS + '_PENDING': pending('analytics_service_requests'); break;
		case types.ANALYTICS_SERVICE_REQUESTS + '_FULFILLED': fulfilled('analytics_service_requests'); break;
                
        case types.ANALYTICS_QUOTES + '_CLEAR': state = { ...state, analytics_quotes: {}}; break;
		case types.ANALYTICS_QUOTES + '_PENDING': pending('analytics_quotes'); break;
		case types.ANALYTICS_QUOTES + '_FULFILLED': fulfilled('analytics_quotes'); break;

        case types.ANALYTICS_INVOICES + '_CLEAR': state = { ...state, analytics_invoices: {}}; break;
		case types.ANALYTICS_INVOICES + '_PENDING': pending('analytics_invoices'); break;
		case types.ANALYTICS_INVOICES + '_FULFILLED': fulfilled('analytics_invoices'); break;

        default: break;
    }

    return state;
    
    function set(table) {
        state = {
            ...state,
			[table]: action.data,
		};
	}
    function pending(table) {
        state = {
            ...state,
            [table + '_pending']: true,
        };
    }
    function save_pending(table) {
        state = {
            ...state,
            [table + '_save_pending']: true,
        };
    }
    function save_fulfilled(table) {
        state = {
            ...state,
            [table + '_save_pending']: false,
        };
    }
    function fulfilled(table) {
        state = {
            ...state,
            [table]: action.data,
            [table + '_pending']: false,
            ...(action.unsubscribe) ? { [table + '_unsubscribe']: (action.unsubscribe) } : {},
        };
    }
    function selected(table) {
        state = {
            ...state,
            [table]: action.data,
        };
    }
};
export default analyticsReducer;


